module.exports = __webpack_public_path__ + "img/tzt1.cc605947.jpg";